import { Spinner } from '@atlas/ui-primitives'
import { useSetWorkfrontScope, useWorkfrontScope } from '@/hooks/useWorkfront'
import { apiErrorMessage } from '@/lib/api-error'
import { notification } from '@/notifications/notification-store'
import { SwitchesCard } from './components/SwitchesCard'
import { WorkfrontHeader } from './shared'

/** Admin › Workfront › Settings: the switches, read and set through the scope; each change is reported in the status bar. */
export function WorkfrontSettingsPage() {
	const scope = useWorkfrontScope()
	const set = useSetWorkfrontScope()
	return (
		<div className="space-y-6">
			<WorkfrontHeader title="Settings" />
			{scope.isLoading ? <Spinner aria-label="Loading the settings" /> : null}
			{scope.isError ? (
				<p className="text-ds-sm text-ds-danger">{apiErrorMessage(scope.error, 'Could not load the settings.')}</p>
			) : null}
			{scope.data ? (
				<SwitchesCard
					entries={scope.data}
					saving={set.isPending}
					onChange={(key, value, done) =>
						set.mutate(
							{ key, value },
							{
								onSuccess: () => notification.success(done),
								onError: (cause) => notification.error(apiErrorMessage(cause, 'Could not change the switch.')),
							},
						)
					}
				/>
			) : null}
		</div>
	)
}
